var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex font-outfit items-start gap-4 p-4 bg-white rounded border border-solid border-gray-300",
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-col items-start justify-center gap-3 flex-1",
        },
        [
          _c(
            "div",
            { staticClass: "flex items-start justify-between w-full" },
            [
              _c("div", { staticClass: "flex w-full mr-7 items-start gap-2" }, [
                _c(
                  "div",
                  [
                    _c("ResourceAvatarNew", {
                      staticClass: "cursor-pointer",
                      attrs: {
                        image: this.note.contractor.user.avatar,
                        initial: _vm.contractorInitials,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col items-start justify-center gap-2 flex-1",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex h-6 items-center justify-between w-full",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-primary-black text-xl font-semibold",
                          },
                          [_vm._v(" " + _vm._s(_vm.contractorFullName) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "hidden sm:inline-flex items-center gap-2",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "inline-flex items-center gap-1" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-sm font-medium text-dark-gray",
                                  },
                                  [_vm._v("Visit date:")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "text-sm text-dark-gray" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formattedDate(this.note.created_at)
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "inline-flex items-center gap-1" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-sm font-medium text-dark-gray",
                                  },
                                  [_vm._v("Note recorded:")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "text-sm text-dark-gray" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formattedTime(this.note.created_at)
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2 w-full" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-sm text-dark-gray whitespace-nowrap",
                          },
                          [_vm._v(_vm._s(_vm.jobTitle))]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _c(
                "ColorIconContainer",
                {
                  staticClass: "flex justify-center items-center h-6 w-6",
                  attrs: { iconStyle: "" },
                  on: { click: _vm.message },
                },
                [_c("MessageIcon")],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "sm:hidden flex justify-between w-full" }, [
            _c("div", { staticClass: "flex flex-col" }, [
              _c("div", { staticClass: "text-sm font-medium text-dark-gray" }, [
                _vm._v("Visit date:"),
              ]),
              _c("div", { staticClass: "text-sm text-dark-gray" }, [
                _vm._v(_vm._s(_vm.formattedDate(this.note.created_at))),
              ]),
            ]),
            _c("div", { staticClass: "flex flex-col" }, [
              _c("div", { staticClass: "text-sm font-medium text-dark-gray" }, [
                _vm._v("Note recorded:"),
              ]),
              _c("div", { staticClass: "text-sm text-dark-gray" }, [
                _vm._v(_vm._s(_vm.formattedTime(this.note.created_at))),
              ]),
            ]),
          ]),
          _c("div", [
            _c(
              "p",
              {
                staticClass: "text-sm text-primary-black font-light leading-6",
              },
              [_vm._v(" " + _vm._s(this.note.note) + " ")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }